// Keep personal priority controls consistent with the season write guard in the API.
export function casePriorityAccess({ season, canEdit, archiveEdit, isAuthenticated }, now = new Date()) {
  if (!isAuthenticated) return { canSetPriority: false, reason: '' };
  if (archiveEdit) return { canSetPriority: true, reason: '' };
  if (!['active', 'recruiting'].includes(season?.status)) {
    return {
      canSetPriority: false,
      reason: season?.status === 'completed'
        ? 'Сезон завершён. Выбранные приоритеты доступны только для просмотра.'
        : 'Выбор кейсов в этом сезоне ещё не открыт.',
    };
  }
  if (season.choices_close_on && now > new Date(`${season.choices_close_on}T23:59:59.999+03:00`)) {
    const deadline = new Date(`${season.choices_close_on}T12:00:00+03:00`).toLocaleDateString('ru-RU', {
      day: 'numeric', month: 'long', year: 'numeric', timeZone: 'Europe/Moscow',
    });
    return {
      canSetPriority: false,
      reason: `Выбор кейсов завершился ${deadline} в 23:59 (МСК). Продлить срок могут организаторы. Ранее выбранные приоритеты сохранены.`,
    };
  }
  if (!canEdit) {
    return {
      canSetPriority: false,
      reason: 'Участие в этом сезоне ещё не подтверждено. Если вы уже прошли отбор, обратитесь к организаторам.',
    };
  }
  return { canSetPriority: true, reason: '' };
}
